module.exports = __webpack_public_path__ + "media/site/images/startups/skilldepository-desktop-4e7f02f6826a90fd0193a2f67713ee1f.png";